import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/cookie-banner.scss";

const COOKIE_KEY = "kiu_cookie_consent_v1";

const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  // Show banner only if user hasn't chosen before
  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      setOpen(true);
    }
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem(COOKIE_KEY, value); // "accepted" | "rejected" | "preferences"
    setOpen(false);
    // here you could later plug in analytics consent logic if you want
  };

  if (!open) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite">
      <div className="cookie-banner__inner">
        <p className="cookie-banner__text">
          By clicking <strong>“Accept”</strong>, you agree to the storing of
          cookies on your device to enhance site navigation, analyse site usage,
          and assist in our marketing efforts. View our{" "}
          <Link to="/privacy-policy" className="cookie-banner__link">
            Privacy Policy
          </Link>{" "}
          for more information.
        </p>

        <div className="cookie-banner__actions">
          <button
            type="button"
            className="cookie-btn cookie-btn--ghost"
            onClick={() => handleChoice("preferences")}
          >
            Preferences
          </button>
          <button
            type="button"
            className="cookie-btn cookie-btn--ghost"
            onClick={() => handleChoice("rejected")}
          >
            Reject
          </button>
          <button
            type="button"
            className="cookie-btn cookie-btn--primary"
            onClick={() => handleChoice("accepted")}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
